




























import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class Footer extends Vue {
  routerJump(router: string): void {
    console.log(this.$route)
    if (this.$route.name === 'Login') {
      this.$message.warning('请先登录')
    } else {
      this.$router.push(router)
    }
  }
}
